import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import "./Auth.css";

export default function Login({ navigateTo }) {
  const { login } = useAuth();

  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");

    const cleanIdentifier = identifier.trim();
    const cleanPassword = password.trim();

    if (!cleanIdentifier) {
      setError("لطفاً شماره موبایل یا ایمیل را وارد کنید");
      return;
    }

    if (!cleanPassword) {
      setError("لطفاً رمز عبور را وارد کنید");
      return;
    }

    setLoading(true);

    try {
      const result = await login(cleanIdentifier, cleanPassword);

      if (result.success) {
        if (result.role === "super_admin" || result.role === "staff") {
          navigateTo("admin");
        } else {
          navigateTo("shop");
        }
      } else {
        setError(result.message || "ورود ناموفق بود");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("خطا در ورود. لطفاً اتصال به دیتابیس را بررسی کنید.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h2>ورود به حساب کاربری</h2>
          <p>به نقش خیال خوش آمدید</p>
        </div>

        <div className="auth-body">
          <button
            type="button"
            className="back-to-shop"
            onClick={() => navigateTo("shop")}
          >
            ← بازگشت به فروشگاه
          </button>

          {error && (
            <div
              className="error-message"
              style={{ textAlign: "center", marginBottom: "20px" }}
            >
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label style={{ textAlign: "right" }}>
                شماره موبایل یا ایمیل
              </label>
              <input
                type="text"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                placeholder="09123456789 یا example@email.com"
                dir="ltr"
                autoComplete="username"
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label style={{ textAlign: "right" }}>رمز عبور</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="********"
                dir="ltr"
                autoComplete="current-password"
                disabled={loading}
              />
            </div>

            <div
              className="forgot-password-wrapper"
              style={{ textAlign: "center", marginBottom: "15px" }}
            >
              <button
                type="button"
                onClick={() => navigateTo("forgot-password")}
                className="forgot-password-btn"
                disabled={loading}
              >
                رمز عبور خود را فراموش کرده‌اید؟
              </button>
            </div>

            <button type="submit" className="auth-button" disabled={loading}>
              {loading ? "در حال ورود..." : "ورود"}
            </button>
          </form>
        </div>

        <div className="auth-footer">
          <p>حساب کاربری ندارید؟</p>
          <button
            type="button"
            onClick={() => navigateTo("register")}
            disabled={loading}
          >
            ثبت‌نام کنید
          </button>
        </div>
      </div>
    </div>
  );
}